/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('dateTooltip', [
  function () {
    return {
      restrict: 'A',

      scope: {
        date: '=dateTooltip',
      },

      link(scope, element) {
        const getFormattedDateTime = function () {
          try {
            return `${moment(scope.date).utc().calendar()} UTC`;
          } catch (err) {
            return `${moment(scope.date)}`;
          }
        };

        const $el = $(element);
        $el.addClass('date-tooltip');
        $el.tooltip({ title: getFormattedDateTime(), animation: false });

        scope.$watch('date', function () {
          const ttData = $el.data('bs.tooltip'); // BS tooltip plugin does not expose API for updating displayed text. Got to do that via its internals.
          if (ttData && ttData.options) {
            $el.data('bs.tooltip').options.title = getFormattedDateTime();
          }
        });
      },
    };
  },
]);
